import React, { useEffect } from "react";
import { observer, inject } from "mobx-react";
import { Loading } from "../UI";
import { useLocation, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";

import AppBar from "./AppBar";
import styled from "styled-components";
import { useMobile } from "../utils/mobile";

const LayoutContainer = styled.div((props) => ({
  height: "100vh",
  width: "100vw",
  minHeight: "100vh",
  margin: 0,
  padding: 0,
  background: props.theme.color.white,
  color: props.theme.color.text,
  overflow: "hidden"
}));

const LoginLayoutContainer = styled.div(({ theme }) => ({
  height: "100%",
  width: "100%",
  minHeight: "100vh",
  padding: 0,
  margin: 0,
  background: theme.color.background,
  color: "#FBFCFC",
}));

const LoadingContainer = (props) => {
  const { isLoading, children } = props;
  if (isLoading) {
    return <Loading loading={isLoading} />;
  }
  return <>{children}</>;
};

const Layout = ({ userStore, children }) => {
  const { i18n } = useTranslation();
  let location = useLocation().pathname;
  const rtlOrLtr = i18n.dir();
  const isMobile = useMobile();

  useEffect(() => {
    i18n.changeLanguage(userStore.language);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userStore.language]);

  useEffect(() => {
    i18n.changeLanguage(userStore.language);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userStore.language]);

  useEffect(() => {
    const body = document.body;
    body.dir = rtlOrLtr;
  }, [rtlOrLtr]);

  return (
    <>
      {location.includes("/login") ||
      location.includes("/forgot_password") ||
      location.includes("/new_password") ? (
        <LoginLayoutContainer>
          <LoadingContainer isLoading={false}>{children}</LoadingContainer>
          <Outlet />
        </LoginLayoutContainer>
      ) : (
        <LayoutContainer isMobile={isMobile}>
          <AppBar>
            {children}
            <Outlet />
          </AppBar>
        </LayoutContainer>
      )}
    </>
  );
};

export default inject("userStore")(observer(Layout));
